import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
//import socket from "./socket/SocketService";


// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import store from "./Redux/Store/store";
import { Provider } from "react-redux";
import MainHeader from "layouts/MainHeader";

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <MaterialUIControllerProvider>
      {/* <MainHeader /> */}
        <App />
      </MaterialUIControllerProvider>
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);
